import { Box, List, ListItem, Typography } from "@mui/material";

interface ComponentInfo {
  title: string
  label: string
}

interface CCHExtraInfoProps {
  components: Record<string, ComponentInfo>
}

const CCHExtraInfo = ({components}: CCHExtraInfoProps) => {
  return (
    <Box sx={{ p: 1 }}>
      <List>
        {Object.values(components).map(({ title, label }) => (
          <ListItem key={title} sx={{ p: 0, mb: 1 }}>
            <Typography variant="body2">
              <Box component="span" fontWeight="bold">{title}:</Box> {label}
            </Typography>
          </ListItem>
        ))}
      </List>
    </Box>
  )
}

export default CCHExtraInfo;